import React from 'react';
import { LinkIcon, LayersIcon, SparklesIcon } from 'lucide-react';
import { IconCard } from '../ui/IconCard';
import { BrandButton } from '../ui/BrandButton';
import { ScrollReveal } from '../ui/ScrollReveal';
export function BuildYourStack() {
  return <section className="relative py-24 md:py-32 bg-[#6B1D4A] overflow-hidden" data-id="element-11">
      {/* Parallax Background Effect (CSS based) */}

      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-12">
        <ScrollReveal data-id="element-13">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-14">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#FFF8F0] mb-6" data-id="element-15">
              Build Your Butter Stack
            </h2>
            <p className="font-body text-lg md:text-xl text-[#F8C8DC] opacity-90" data-id="element-16">
              Made to mix, match, and layer. Designed to stack your way — every
              day, every outfit.
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-16" data-id="element-17">
          <ScrollReveal direction="up" delay={100} data-id="element-18">
            <IconCard icon={<LinkIcon className="w-8 h-8" data-id="element-20" />} title="Start with a base" description="Choose a classic chain or choker to set the foundation of your look." data-id="element-19" />
          </ScrollReveal>

          <ScrollReveal direction="up" delay={300} data-id="element-21">
            <IconCard icon={<LayersIcon className="w-8 h-8" data-id="element-23" />} title="Add your layers" description="Mix metals, add texture with pearls, and play with different lengths." data-id="element-22" />
          </ScrollReveal>

          <ScrollReveal direction="up" delay={500} data-id="element-24">
            <IconCard icon={<SparklesIcon className="w-8 h-8" data-id="element-26" />} title="Make it yours" description="Finish with charms or a statement piece that screams 'you'." data-id="element-25" />
          </ScrollReveal>
        </div>

        <ScrollReveal direction="up" delay={700} data-id="element-27">
          <div className="text-center" data-id="element-28">
            <BrandButton href="https://shop.butter-blonde.com" external variant="butter" className="text-lg px-10" data-id="element-29">
              Shop the Stack
            </BrandButton>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}